<template>
  <div class="content-empty mb-4" :class="[(noBorder) ? 'noBorder' : '']" >
    <div class="text-center">
      <img
        class="content-empty__image"
        src="../../../assets/img/empty-feed.svg"
        alt="Empty Feed"
      />
      <h6 class="content-empty__title mt-2" v-if="allowNewPost">Be the first to post here</h6>
      <h6 class="content-empty__title mt-2" v-if="!allowNewPost">{{ alternativeText }}</h6>
      <button class="btn btn-primary mx-auto mt-4" v-if="allowNewPost" @click="spawnStateChangeInCirclePage(CIRCLE_STATES[1])">
        <ion-icon name="ios-add-circle"></ion-icon>New Post
      </button>
    </div>
  </div>
</template>

<script>
    export default {
        name: "EmptyFeed",
        props: ["emptyFeedFor", "altText", "canUserCreateContent", "noBorder", "CIRCLE_STATES"],
        computed: {
          allowNewPost: function() {
            return this.$props.emptyFeedFor === "circle" && this.$props.canUserCreateContent;
          },
          alternativeText: function () {
            let text = "";
            this.$props.altText ? text = this.$props.altText : text = "No posts found";
            return text;
          }
        },
        methods: {
          spawnStateChangeInCirclePage(emittedState) {
            this.$root.$emit("stateChangeFromEmptyFeed", emittedState);
          }
        }
    }
</script>

<style lang="scss" scoped>
  .noBorder {
    border: none !important;
  }
</style>